import { request } from '@/shared/api/request'

export const createEditEquipmentData = ({data, payload}) => {
	return request({ url: `/assessment/dict/${payload.type}/createOrEdit`, method: 'POST', data })
}
